/**
 * Report Routes.
 */
export const report = {
  exportReport: '/report/export-report',
}
